export default __webpack_public_path__ + "static/media/Call.c982bbb9.svg";